export const FETCH_PERMISSIONS_REQUEST = "FETCH_PERMISSIONS_REQUEST";
export const FETCH_PERMISSIONS_SUCCESS = "FETCH_PERMISSIONS_SUCCESS";
export const FETCH_PERMISSIONS_FAILURE = "FETCH_PERMISSIONS_FAILURE";

export const FETCH_PERMISSIONS_APPS = "FETCH_PERMISSIONS_APPS";

export const REQUEST_HANDLER = "REQUEST_HANDLER";
export const REQUEST_SUCCESS = "REQUEST_SUCCESS";
export const REQUEST_FAILURE = "REQUEST_FAILURE";

export const UPDATE_PERMISSIONS = "UPDATE_PERMISSIONS";
export const DELETE_PERMISSIONS = "DELETE_PERMISSIONS";
